/**
 * Golden Desserts - Add to Cart enhancement
 * --------------------------------------
 * Progressively enhances any <form data-aseel-add-form> on the page:
 *   1. Adds the item via Shopify's documented Ajax Cart API (/cart/add.js)
 *   2. Refreshes the theme's native cart drawer via the Section Rendering
 *      API (/?section_id=cart-drawer-section)
 *   3. Opens the native cart drawer using its own public open() method
 *   4. Updates any [data-aseel-cart-count] badges from /cart.js
 *
 * If anything above fails (network error, JS disabled, cart set to
 * "page" instead of "drawer"), the form still works: it either falls
 * back to a real, uninterrupted form submission, or the item is simply
 * already in the cart and the shopper can view /cart normally.
 */
(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';
  var CART_JSON_URL = '/cart.js';
  var DRAWER_SECTION_URL = '/?section_id=cart-drawer-section';
  var DRAWER_WRAPPER_ID = 'shopify-section-cart-drawer-section';

  function updateCartBadges(count) {
    var badges = document.querySelectorAll('[data-aseel-cart-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count;
      if (count > 0) {
        badges[i].removeAttribute('hidden');
      } else {
        badges[i].setAttribute('hidden', '');
      }
    }
  }

  function refreshCartBadge() {
    fetch(CART_JSON_URL, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartBadges(cart.item_count || 0);
      })
      .catch(function () {
        /* non-fatal: badge just won't update */
      });
  }

  function openNativeCartDrawer() {
    var open = function () {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        try {
          drawer.open();
        } catch (err) {
          window.location.href = '/cart';
        }
      }
    };

    if (window.customElements && window.customElements.whenDefined) {
      window.customElements
        .whenDefined('theme-drawer')
        .then(open)
        .catch(open);
    } else {
      open();
    }
  }

  function refreshCartDrawer() {
    return fetch(DRAWER_SECTION_URL, { headers: { Accept: 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Could not refresh cart drawer');
        return res.text();
      })
      .then(function (html) {
        var freshDoc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = freshDoc.getElementById(DRAWER_WRAPPER_ID);
        var current = document.getElementById(DRAWER_WRAPPER_ID);

        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          openNativeCartDrawer();
        } else {
          // Cart type isn't "drawer" (or markup not found) - just send
          // the shopper to the real cart page instead.
          window.location.href = '/cart';
        }
      });
  }

  function setButtonState(button, state, originalText) {
    if (!button) return;
    if (state === 'loading') {
      button.disabled = true;
      button.dataset.originalText = button.dataset.originalText || originalText;
      button.textContent = 'Adding…';
      button.classList.add('is-loading');
      button.classList.remove('is-added');
    } else if (state === 'added') {
      button.textContent = 'Added ✓';
      button.classList.remove('is-loading');
      button.classList.add('is-added');
    } else if (state === 'reset') {
      button.disabled = false;
      button.textContent = button.dataset.originalText || originalText;
      button.classList.remove('is-loading', 'is-added');
    }
  }

  function handleSubmit(event) {
    var form = event.currentTarget;
    var button = form.querySelector('button[type="submit"]');
    var originalText = button ? button.textContent : 'Add to Cart';

    // If the browser doesn't support fetch, let the form submit normally.
    if (!window.fetch) return;

    event.preventDefault();
    setButtonState(button, 'loading', originalText);

    var formData = new FormData(form);

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var message = (data && data.description) || 'Unable to add this item to your cart.';
            throw new Error(message);
          }
          return data;
        });
      })
      .then(function () {
        setButtonState(button, 'added', originalText);
        refreshCartBadge();
        return refreshCartDrawer();
      })
      .catch(function (err) {
        console.error('[aseel-cart] add to cart failed, falling back to full submit:', err);
        setButtonState(button, 'reset', originalText);
        // Guaranteed-to-work fallback: submit the form for real.
        HTMLFormElement.prototype.submit.call(form);
        return;
      })
      .then(function () {
        window.setTimeout(function () {
          setButtonState(button, 'reset', originalText);
        }, 2200);
      });
  }

  function init() {
    var forms = document.querySelectorAll('[data-aseel-add-form]');
    for (var i = 0; i < forms.length; i++) {
      forms[i].addEventListener('submit', handleSubmit);
    }
    refreshCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
